import { getLocalTimeZone, today } from "@internationalized/date";

export enum DateFilterValue {
  Equal = "=",
  NotEqual = "!=",
  LessThan = "<",
  GreaterThan = ">",
  GreaterThanOrEqual = ">=",
  LessThanOrEqual = "<=",
  Contains = "=*",
  NotContains = "!*",
  StartsWith = "^",
  NotStartsWith = "!^",
  EndsWith = "$",
  NotEndsWith = "!$",
}

// Filter configuration
export interface DateFilterOption {
  value: DateFilterValue;
  label: string;
  getDate: () => string;
  getTabValue: () => string;
}

// Filter options configuration
export const dateFilterOptions: DateFilterOption[] = [
  {
    value: DateFilterValue.LessThan,
    label: "Verleden",
    getDate: () => String(today(getLocalTimeZone())),
    getTabValue: () => `${DateFilterValue.LessThan}:${String(today(getLocalTimeZone()))}`,
  },
  {
    value: DateFilterValue.GreaterThanOrEqual,
    label: "Alles",
    getDate: () => "",
    getTabValue: () => `${DateFilterValue.GreaterThanOrEqual}:`,
  },
];
